import React from 'react';
import { useAdminData } from '../useAdminData';
import MetaEditor from '../editors/MetaEditor';

const GlobalSettingsPage = () => {
  const { formData, isLoading, isSaving, error, success, handleFormChange, handleSave } = useAdminData();

  if (isLoading) return <div>Betöltés...</div>;
  if (!formData) return <div>{error || "Hiba az adatok betöltésekor."}</div>;

  return (
    <div>
      <div className="admin-page-header">
        <h1>Globális Beállítások</h1>
        <div>
          {success && <span className="success-message">{success}</span>}
          <button onClick={handleSave} className="save-button" disabled={isSaving}>
            {isSaving ? 'Mentés...' : 'Mentés'}
          </button>
        </div>
      </div>
      <MetaEditor meta={formData.siteMeta} onFormChange={handleFormChange} />
    </div>
  );
};

export default GlobalSettingsPage;